import React, { useEffect, useRef, useState } from 'react';
import { FileDown, Loader2, ChevronDown } from 'lucide-react';
import { authAPI } from '../services/api';
import { useT } from '../services/i18n';

const ALL = [['fr', 'Français'], ['en', 'English'], ['de', 'Deutsch'], ['es', 'Español'], ['it', 'Italiano']];
const COUNTRY_LANG = { allemagne: 'de', germany: 'de', deutschland: 'de', autriche: 'de', austria: 'de', suisse: 'de', schweiz: 'de', espagne: 'es', spain: 'es', 'españa': 'es', france: 'fr', fr: 'fr', belgique: 'fr', belgium: 'fr', luxembourg: 'fr' };

// Default language: the customer's saved preference, else inferred from the order country
const defaultLang = (order) => authAPI.docLang() || COUNTRY_LANG[((order.billing_info || {}).country || (order.shipping_info || {}).country || 'France').trim().toLowerCase()] || 'en';

// Invoice download split-menu: FR / EN / DE / ES, customer's default language first
const InvoiceLangMenu = ({ order, onDownload, label, className = '', testId = `order-invoice-${order.id}`, variant = 'link' }) => {
  const { t } = useT();
  const text = label || t('orders.invoicePdf');
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState('');
  const ref = useRef(null);
  useEffect(() => { const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }; document.addEventListener('mousedown', h); return () => document.removeEventListener('mousedown', h); }, []);
  const def = defaultLang(order);
  const langs = [...ALL.filter(([c]) => c === def), ...ALL.filter(([c]) => c !== def)];
  const run = async (lang) => { setBusy(lang); setOpen(false); try { await onDownload(lang); } finally { setBusy(''); } };
  const base = variant === 'button' ? 'inline-flex items-center gap-1 rounded-md bg-orange-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-orange-600' : variant === 'icon' ? 'p-2 text-orange-600 hover:bg-orange-50 rounded inline-flex items-center' : 'text-xs text-blue-600 hover:underline inline-flex items-center gap-1';
  return (
    <div className={`relative inline-block ${className}`} ref={ref}>
      <button type="button" data-testid={testId} onClick={() => setOpen((o) => !o)} className={base} title={text}>
        {busy ? <Loader2 size={14} className="animate-spin" /> : <FileDown size={14} />}{variant !== 'icon' && <span className="ml-0.5">{text}</span>}<ChevronDown size={12} className="ml-0.5 opacity-70" />
      </button>
      {open && (
        <div className="absolute right-0 z-30 mt-1 w-40 rounded-md border border-gray-200 bg-white shadow-lg py-1 text-sm" data-testid={`${testId}-menu`}>
          {langs.map(([code, name]) => (
            <button key={code} type="button" onClick={() => run(code)} className="flex w-full items-center justify-between px-3 py-1.5 text-left text-gray-700 hover:bg-gray-50" data-testid={`${testId}-${code}`}>
              <span>{name}</span><span className="text-[10px] uppercase text-gray-400">{code}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default InvoiceLangMenu;
